/** @format */

import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
// import Spinner from "../components/Spinner/Spinner";

const HomeWrapper = dynamic(() => import("../components/HomePage/Home"), {
  ssr: false,
  // loading: () => <Spinner />,
});

export default function Home() {
  const meta = {
    title: "Global sourcing from India | Verified suppliers from India- Qalara",
       //"Qalara | Global sourcing & wholesale | Verified wholesale suppliers from India",
    description: "Source artisanal, handcrafted, and conscious lifestyle goods from India. From décor to fashion, Qalara offers white label and made-to-order solutions with end-to-end global delivery and consolidated shipping support.",
      //"Global wholesale market for sourcing artisanal & sustainable lifestyle goods - Décor, Rugs ,Carpets, Kitchen, Fashion, Kids, Toys, Cushions, Home linen, vases",
    keywords:
      "handmade, fair trade, ecofriendly, wholesale buying, global sourcing, bulk items, India, Exporters from India, Verified manufacturers and suppliers and wholesalers, wholesale home décor, wholesale home linen, wholesale kitchenware, wholesale fashion, wholesale homeware, wholesale furniture, wholesale jewellery, wholesale toys, wholesale clothing, wholesale candles, wholesale ceramics, wholesale vases, lanterns, copper wholesale, home wholesale, candle wholesale, items wholesale, furniture wholesale, gifts, pottery, items wholesale, farmhouse pottery, handmade ceramic mugs, handmade cutting boards, handmade clothing, fair trade rugs, wholesale outdoor furniture suppliers, wholesale homeware, furniture exporters from india, Sydney Gift Fair, sydney gift fair 2023, agha sydney gift fair 2023, reed gift fair sydney, agha sydney gift fair exhibitor list, melbourne gift fair 2023, agha gift fair 2023, agha gift fair",
    url: "/",
  };

  return (
    <Layout meta={meta}>
      <section style={{ display: "none" }}>
        <h1>Global sourcing from India. One stop solution for home & lifestyle goods.</h1>
        <h2>Your trusted partner for sustainable & custom production</h2>
        <h3>White label & made-to-order solutions</h3>
        <h4>Handcrafted, ethical, and globally competitive</h4>
        <h5>Explore our product categories: Décor, Rugs, Kitchen, Fashion & more</h5>
        <h6>Consolidated shipments, seamless logistics & quality assurance built in</h6>
      </section>
      <HomeWrapper />
    </Layout>
  );
}
